module.exports = __webpack_public_path__ + "static/img/29.b2ae4cd8.jpg";